module.exports = __webpack_public_path__ + "static/media/20.1fdd148f.svg";